export const REVIEWS_LOADING_START = 'REVIEWS/LOADING_START';
export const REVIEWS_PENDING_START = 'REVIEWS/PENDING_START';
export const REVIEWS_LOADING_END = 'REVIEWS/LOADING_END';
export const REVIEWS_PENDING_END = 'REVIEWS/PENDING_END';
export const REVIEWS_GET_USER_ASSIGNMENTS = 'REVIEWS/GET_USER_ASSIGNMENTS';
export const REVIEWS_GET_ASSIGNMENT = 'REVIEWS/GET_ASSIGNMENT';
// export const REVIEWS_GET_REPORT_HIGHLIGHTS = 'REVIEWS/GET_REPORT_HIGHLIGHTS';
export const REVIEWS_UPDATE_HIGHLIGHTS = 'REVIEWS/REPORT_UPDATE_HIGHLIGHTS';
export const REVIEWS_UPDATE_ASSIGNMENT_ID = 'REVIEWS/REVIEWS_UPDATE_ASSIGNMENT_ID';
